import React, { useState, useEffect } from "react";
import TextBox from "../components/TextBox";
import "../styles/login.css";
import Loader from "../components/Loader";
import { registerUser } from "../api/service";
import { useNavigate } from "react-router-dom";
import { firebase, firebaseConfig } from "../firebase";
import useGeoLocation from "../hooks/useGeolocation";
import Axios from "axios";
import { profileUser } from "../api/service";
// const googleTranslateElementInit = () => {
//   new window.google.translate.TranslateElement(
//     {
//       pageLanguage: "en",
//       autoDisplay: false
//     },
//     "google_translate_element"
//   );
// };

const Register = () => {
  // Init states
  let token = localStorage.getItem("token");
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [user_id, setId] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [referral, setReferral] = useState("");
  const [loader, setLoader] = useState(false);
  const [fcmToken, setToken] = useState("");
  const { latitude, longitude, error } = useGeoLocation();
  console.log(latitude);
  console.log(longitude);
  const navigate = useNavigate();
  const profileInit = async () => {
    try {
      const response = await profileUser(token);
      if (response.data.status !== "failed") {
        console.log("profile id", response.data.userValidation._id);
        setId(response.data.userValidation._id);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };
  useEffect(() => {
    console.log("Inside useEffect");

    const initializeFirebase = async () => {
      try {
        // Check if Firebase is not initialized
        if (!firebase.apps.length) {
          firebase.initializeApp(firebaseConfig);
        }

        const messaging = firebase.messaging();

        // Register the service worker
        navigator.serviceWorker
          .register("/firebase-messaging-sw.js")
          .then((registration) => {
            console.log(
              "Service Worker registered with scope:",
              registration.scope
            );
          })
          .catch((error) => {
            console.error("Error registering Service Worker:", error);
          });

        // await messaging.requestPermission();
        const fcmToken = await messaging.getToken();

        // Update the token state
        setToken(fcmToken);
        console.warn("Set Token:", fcmToken);
        // Call the function to send the token to the server
        //sendTokenToServer(fcmToken,mobileNumber);

        // const displayNotification = (message) => {
        //   toast.info(message);
        // };

        // messaging.onMessage((message) => {
        //   console.log("Received FCM message:", message);

        // Extract the message content
        // const notificationMessage = message.notification.body;
        // console.log("Notification Message:", notificationMessage);
        // displayNotification(notificationMessage);
        // });
      } catch (error) {
        console.error("Error initializing Firebase messaging:", error);
      }
    };

    initializeFirebase();
    console.log("Firebase initialized");
  }, [setToken]);

  const register = async (event) => {
    event.preventDefault();
    setLoader(true);

    // Create a new user
    if (name !== "" && mobileNumber !== "" && email !== "" && password !== "") {
      if (password !== confirmPassword) {
        setLoader(false);
        alert("Passwords do not match");
      } else {
        setLoader(false);
        try {
          // Check if the referral token is valid
          console.log("Checking")
          const response = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/getReferral/${referral}`);
          console.log(response)
          if ((response).data.length>0 || referral === "") {
            // Referral token is valid, proceed with user registration
            
            const user = {
              name: name,
              mobile: Number(mobileNumber),
              email: email,
              latitude: latitude,
              longitude: longitude,
              password: password,
              confirmPassword: confirmPassword,
              fcmToken: fcmToken,
            };

            // Clear form fields
            setName("");
            setEmail("");
            setMobileNumber("");
            setPassword("");
            setConfirmPassword("");
            setReferral("");
            // Register the user
            registerUser(user)
          .then((req, res) => {
            // navigate("/");
            console.log("testing")
            console.log(req.data);
            const { status, message } = req.data;
            console.log(status, message);
            if (status === "failed") {
              alert(message);
            } else {
              // alert(message);
              // sendTokenToServer(fcmToken, mobileNumber);
              navigate("/");
            }
          })
          .catch((error) => {
            alert("Error in creating user " + error.message);
          });
          } else {
            navigate("/");
          }
        } catch (error) {
          alert("Invalid Referral Code");
        }
      }
    }
  };

  // useEffect(() => {
  //   var addScript = document.createElement("script");
  //   addScript.setAttribute(
  //     "src",
  //     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
  //   );
  //   document.body.appendChild(addScript);
  //   window.googleTranslateElementInit = googleTranslateElementInit;
  // }, []);

  return (
    <div className="flex flex-col items-center dakr:bg-[#0d1117] bg-[#FAF7F0] bg-cover ">
      {loader && (
        <div className="z-10 absolute flex flex-row items-center justify-center h-full w-full">
          <Loader />
        </div>
      )}
      <div className="flex mt-12 sm:mt-6">
        {/* <img src={logo} alt="logo" className="inline w-10 h-10" /> */}
        <h1 className="text-4xl sm:text-2xl md:text-4xl cursor-pointer pl-0 font-bold bg-clip-text text-[#c9d1d9]">
          <span className="inline-block text-[#3B7BD3] dark:text-[#FAF7F0]">
            JAL SURA
            <span className="text-red-600">क</span>
            SHA
          </span>
        </h1>
      </div>
      <form
        onSubmit={register}
        className="p-6 dark:bg-[#161b22] bg-[#c3d5ee] h-full flex flex-col items-start drop-shadow-2xl mt-16 md:mt-12 w-5/6 sm:w-1/2 lg:w-1/3 rounded-xl shadow-2xl"
      >
        <h2 class="text-[#161b22]  dark:text-[#FAF7F0] font-semibold mb-4 text-2xl self-center">
          REGISTER
        </h2>
        <TextBox
          textInput="text-md text-gray-500"
          textLabel="text-md text-gray-500"
          width="w-full"
          height="h-12"
          hint="Name"
          position="left-2 sm:left-3 top-2.5"
          border="border-[#161b22] border-2"
          span="px-1"
          input="px-3 sm:px-4"
          div="mt-8"
          type="text"
          setState={setName}
          value={name}
        />
        <TextBox
          textInput="text-md text-gray-500"
          textLabel="text-md text-gray-500"
          width="w-full"
          height="h-12"
          hint="Mobile Number"
          position="left-2 sm:left-3 top-2.5"
          border="border-[#161b22] border-2"
          span="px-1"
          input="px-3 sm:px-4"
          div="mt-6"
          type="text"
          setState={setMobileNumber}
          value={mobileNumber}
        />
        <TextBox
          textInput="text-md text-gray-500"
          textLabel="text-md text-gray-500"
          width="w-full"
          height="h-12"
          hint="Email ID"
          position="left-2 sm:left-3 top-2.5"
          border="border-[#161b22] border-2"
          span="px-1"
          input="px-3 sm:px-4"
          div="mt-6"
          type="email"
          setState={setEmail}
          value={email}
        />

        <TextBox
          textInput="text-md text-gray-500"
          textLabel="text-md text-gray-500"
          width="w-full"
          height="h-12"
          hint="Password"
          position="left-2 sm:left-3 top-2.5"
          border="border-[#161b22] border-2"
          span="px-1"
          input="px-3 sm:px-4"
          div="mt-6"
          type="password"
          setState={setPassword}
          value={password}
        />
        <TextBox
          textInput="text-md text-gray-500"
          textLabel="text-md text-gray-500"
          width="w-full"
          height="h-12"
          hint="Confirm Password"
          position="left-2 sm:left-3 top-2.5"
          border="border-[#161b22] border-2"
          span="px-1"
          input="px-3 sm:px-4"
          div="mt-6"
          type="password"
          setState={setConfirmPassword}
          value={confirmPassword}
        />
        <TextBox
          textInput="text-md text-gray-500"
          textLabel="text-md text-gray-500"
          width="w-full"
          height="h-12"
          hint="Referral Code(Optional)"
          position="left-2 sm:left-3 top-2.5"
          border="border-[#161b22] border-2"
          span="px-1"
          input="px-3 sm:px-4"
          div="mt-6"
          type="text"
          setState={setReferral}
          value={referral}
        />

        <button
          type="submit"
          className="shadow-none w-full text-[#161b22]  dark:text-[#FAF7F0] bg-[#3B7BD3] hover:bg-[#699be2] font-bold py-2 px-4  rounded-xl h-10 my-4"
        >
          Continue
        </button>
        <h1 className=" text-[#161b22]  dark:text-[#FAF7F0] text-sm text-left mx-1">
          By continuing, you agree to Jal Suraksha's privacy notice and
          conditions of use.
        </h1>
      </form>
      <p className="text-[#161b22]  dark:text-[#FAF7F0] mt-4 py-4 font-semibold ">
        Already have an account?{" "}
        <span
          onClick={() => navigate("/")}
          className="underline cursor-pointer font-normal text-[#2f81e3]"
        >
          Sign in
        </span>
      </p>
      {/* <div className=" bottom-0  bg-gray-500 bg-opacity-20 backdrop-filter backdrop-blur-lg flex flex-col items-center w-full h-10 pt-2">
        <span className="text-white">Mumbai | All rights reserved</span>
      </div> */}
    </div>
  );
};

export default Register;
